import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CallsService } from '@rspl-api';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as fromActions from './call.actions';

@Injectable()
export class CallEffects {
  getCalls = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getCalls),
      switchMap((params) =>
        this.callService.filter({ lead_id: params.leadId }).pipe(
          map((result) => {
            return fromActions.getCallsSuccess({
              results: result.results,
              resultsCount: result.totalResults,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private callService: CallsService,
  ) {}
}
